module.exports = __webpack_public_path__ + "static/media/u45_premium_contract3.97bcdb92.webp";